document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('a[href*="#"]').forEach((link) => {
    link.addEventListener('click', () => {
      const drawer = document.querySelector('header-drawer details[open], .menu-drawer[open], dialog[open]');
      if (drawer) {
        if (typeof drawer.close === 'function') {
          drawer.close();
        } else {
          drawer.removeAttribute('open');
        }
      }

      document.body.classList.remove('overflow-hidden', 'scroll-lock');
      document.body.style.removeProperty('overflow');
      document.documentElement.style.removeProperty('overflow');
      document.body.style.removeProperty('position');
    });
  });
});